
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("@embroider/macros/es-compat2", function(){ return i("@embroider/macros/es-compat2");});
d("@embroider/macros/runtime", function(){ return i("@embroider/macros/runtime");});
d("ember-arg-types/-private/closest-string", function(){ return i("ember-arg-types/-private/closest-string");});
d("ember-arg-types/-private/is-element-descriptor", function(){ return i("ember-arg-types/-private/is-element-descriptor");});
d("ember-arg-types/-private/throw-console-error", function(){ return i("ember-arg-types/-private/throw-console-error");});
d("ember-arg-types/decorator", function(){ return i("ember-arg-types/decorator");});
d("ember-arg-types/index", function(){ return i("ember-arg-types/index");});
import "ember-modifier/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "@embroider/macros/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-arg-types/-embroider-implicit-modules.js";
